var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup48354(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48354",
    "data-name": "Group 48354",
    transform: "translate(-656 -1271)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1_copy",
    "data-name": "Rectangle 1 copy",
    width: 600,
    height: 600,
    rx: 300,
    transform: "translate(656 1271)",
    fill: "#0267c1",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1_copy-2",
    "data-name": "Rectangle 1 copy",
    width: 510,
    height: 510,
    rx: 255,
    transform: "translate(701 1316)",
    fill: "#0267c1",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1_copy-3",
    "data-name": "Rectangle 1 copy",
    width: 420,
    height: 420,
    rx: 210,
    transform: "translate(746 1361)",
    fill: "#0267c1",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1_copy-4",
    "data-name": "Rectangle 1 copy",
    width: 330,
    height: 330,
    rx: 165,
    transform: "translate(791 1406)",
    fill: "#0267c1",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1_copy-5",
    "data-name": "Rectangle 1 copy",
    width: 246,
    height: 246,
    rx: 123,
    transform: "translate(833 1448)",
    fill: "#0267c1",
    opacity: 0.03
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48354);
export default __webpack_public_path__ + "static/media/Group 48354.b31fdc1877eed7ba85e00e255e625589.svg";
export { ForwardRef as ReactComponent };